import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCaretUp = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.65383 13.85L11.4513 9.05255C11.7543 8.74952 12.2457 8.74952 12.5487 9.05255L17.3462 13.85C17.835 14.3389 17.4888 15.1747 16.7975 15.1747L7.20252 15.1747C6.51121 15.1747 6.16501 14.3389 6.65383 13.85Z",
		fill: "currentColor"
	})
});
export default SvgCaretUp;
